export default "__VITE_ASSET__fijbQjJD__"